// extracted by mini-css-extract-plugin
export default {"root":"NotificationCenterModal_root__iVPDO","notifications":"NotificationCenterModal_notifications__PosBf"};